<div class="header-program-infos">
  <span>Program Information</span>
  <button
    md-tooltip="Contact programming team"
    md-raised-button
    formtarget="_blank"
    style="min-width: 48px"
    onclick="location.href='https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=dl_programming_wbdsportseurope@discovery.com&su=Request for intervention'"
  >
    <md-icon>outgoing_mail</md-icon>
  </button>
  <button
    md-tooltip="Reload program"
    md-raised-button
    (click)="loadProgram()"
    style="min-width: 48px"
  >
    <md-icon>refresh</md-icon>
  </button>
  <span
    [mdTooltip]="externalEvents"
    *ngIf="externalEvents !== ''"
    class="metadata"
  >
    <md-icon>link</md-icon>
  </span>
  <span [mdTooltip]="affiliates" *ngIf="affiliates !== ''" class="metadata">
    <md-icon>settings_input_antenna</md-icon>
  </span>
  <span [mdTooltip]="territories" *ngIf="territories !== ''" class="metadata">
    <md-icon>copyrights</md-icon>
  </span>
  <span [mdTooltip]="websites" *ngIf="websites !== ''" class="metadata">
    <md-icon>wifi</md-icon>
  </span>
  <span [mdTooltip]="audios" *ngIf="audios !== ''" class="metadata">
    <md-icon>volume_up</md-icon>
  </span>
</div>
<div *ngIf="!loading && programArticle !== null">
  <div>
    <md-card>
      <div class="information" md-card-content *ngIf="programArticle">
        <div>
          <div *ngIf="programArticle.isSport" class="information-item">
            <span
              (mouseenter)="GetSportAndEventPictures()"
              mdTooltipPosition="left"
              [mdTooltip]="
                'Sport: ' + programArticle.sport.id | undefinedString
              "
              >Sport:</span
            >
            <a
              *ngIf="programArticle.sport.value"
              [routerLink]="['/translate/2/null/', programArticle.sport.value]"
            >
              <span
                [ngClass]="{
                  'not-translated': !programArticle.sport.isTranslated
                }"
                >{{ programArticle.sport.value | undefinedString }}</span
              >
            </a>
            <b *ngIf="!programArticle.sport.value">{{
              programArticle.sport.value | undefinedString
            }}</b>
            <p *ngIf="sportPicture != ''" class="image-tooltip">
              <img
                (click)="editSportPicture()"
                [src]="
                  sportPicture ||
                  'https://i.eurosport.com/taiga/Pictogram/placeholder1.png'
                "
                width="150"
              />
              <img
                (click)="editElementPictogram(programArticle.sport.id, '2')"
                [src]="
                  sportPictogram ||
                  'https://i.eurosport.com/taiga/Pictogram/placeholder1.png'
                "
                width="64"
              />
            </p>
          </div>
          <div *ngIf="programArticle.isSport" class="information-item">
            <span
              mdTooltipPosition="left"
              [mdTooltip]="
                'Competition: ' + programArticle.competition.id
                  | undefinedString
              "
              >Competition:</span
            >
            <a
              *ngIf="programArticle.competition.value"
              [routerLink]="[
                '/translate/3/null/',
                programArticle.competition.value
              ]"
            >
              <span
                [ngClass]="{
                  'not-translated': !programArticle.competition.isTranslated
                }"
                >{{ programArticle.competition.value | undefinedString }}</span
              >
            </a>
            <b *ngIf="!programArticle.competition.value">{{
              programArticle.competition.value | undefinedString
            }}</b>
          </div>
          <div *ngIf="programArticle.isSport" class="information-item">
            <span
              mdTooltipPosition="left"
              [mdTooltip]="
                'Event: ' + programArticle.event.id | undefinedString
              "
              >Event:</span
            >
            <a
              *ngIf="programArticle.event.value"
              [routerLink]="['/translate/4/null/', programArticle.event.value]"
            >
              <span
                [ngClass]="{
                  'not-translated': !programArticle.event.isTranslated
                }"
                >{{ programArticle.event.value | undefinedString }}</span
              >
            </a>
            <b *ngIf="!programArticle.event.value">{{
              programArticle.event.value | undefinedString
            }}</b>
            <p *ngIf="eventPictogram != ''" class="image-tooltip">
              <img
                (click)="editElementPictogram(programArticle.event.id, '4')"
                [src]="
                  eventPictogram ||
                  'https://i.eurosport.com/taiga/Pictogram/placeholder1.png'
                "
                width="64"
              />
            </p>
          </div>
          <div *ngIf="programArticle.isSport" class="information-item">
            <span
              mdTooltipPosition="left"
              [mdTooltip]="
                'Round: ' + programArticle.round.id | undefinedString
              "
              >Round:</span
            >
            <a
              *ngIf="programArticle.round.value"
              [routerLink]="['/translate/6/null/', programArticle.round.value]"
            >
              <span
                [ngClass]="{
                  'not-translated': !programArticle.round.isTranslated
                }"
                >{{ programArticle.round.value | undefinedString }}</span
              >
            </a>
            <b *ngIf="!programArticle.round.value">{{
              programArticle.round.value | undefinedString
            }}</b>
          </div>
          <div *ngIf="programArticle.isSport" class="information-item">
            <span
              mdTooltipPosition="left"
              [mdTooltip]="
                'Discipline: ' + programArticle.discipline.id | undefinedString
              "
              >Discipline:</span
            >
            <a
              *ngIf="programArticle.discipline.value"
              [routerLink]="[
                '/translate/5/null/',
                programArticle.discipline.value
              ]"
            >
              <span
                [ngClass]="{
                  'not-translated': !programArticle.discipline.isTranslated
                }"
                >{{ programArticle.discipline.value | undefinedString }}</span
              >
            </a>
            <b *ngIf="!programArticle.discipline.value">{{
              programArticle.discipline.value | undefinedString
            }}</b>
          </div>
          <div *ngIf="programArticle.isSport" class="information-item">
            <span
              mdTooltipPosition="left"
              [mdTooltip]="
                'Gender: ' + programArticle.gender.id | undefinedString
              "
              >Gender:</span
            >
            <a
              *ngIf="programArticle.gender.value"
              [routerLink]="['/translate/7/null/', programArticle.gender.value]"
            >
              <span
                [ngClass]="{
                  'not-translated': !programArticle.gender.isTranslated
                }"
                >{{ programArticle.gender.value | undefinedString }}</span
              >
            </a>
            <b *ngIf="!programArticle.gender.value">{{
              programArticle.gender.value | undefinedString
            }}</b>
          </div>
          <div *ngIf="programArticle.isSport" class="information-item">
            <span
              mdTooltipPosition="left"
              [mdTooltip]="'Age: ' + programArticle.age.id | undefinedString"
              >Age:</span
            >
            <a
              *ngIf="programArticle.age.value"
              [routerLink]="['/translate/8/null/', programArticle.age.value]"
            >
              <span
                [ngClass]="{
                  'not-translated': !programArticle.age.isTranslated
                }"
                >{{ programArticle.age.value | undefinedString }}</span
              >
            </a>
            <b *ngIf="!programArticle.age.value">{{
              programArticle.age.value | undefinedString
            }}</b>
          </div>
          <div
            *ngIf="!programArticle.isSport && programArticle.type.value"
            class="information-item"
          >
            <span
              mdTooltipPosition="left"
              [mdTooltip]="'Type: ' + programArticle.type.id | undefinedString"
              >Type:</span
            >
            <a
              *ngIf="programArticle.type.value"
              [routerLink]="['/translate/12/null/', programArticle.type.value]"
            >
              <span
                [ngClass]="{
                  'not-translated': !programArticle.type.isTranslated
                }"
                >{{ programArticle.type.value | undefinedString }}</span
              >
            </a>
          </div>
          <div
            *ngIf="!programArticle.isSport && programArticle.group.value"
            class="information-item"
          >
            <span
              mdTooltipPosition="left"
              [mdTooltip]="
                'Group: ' + programArticle.group.id | undefinedString
              "
              >Group:</span
            >
            <a
              *ngIf="programArticle.group.value"
              [routerLink]="['/translate/9/null/', programArticle.group.value]"
            >
              <span
                [ngClass]="{
                  'not-translated': !programArticle.group.isTranslated
                }"
                >{{ programArticle.group.value | undefinedString }}</span
              >
            </a>
          </div>
          <div
            *ngIf="!programArticle.isSport && programArticle.label.value"
            class="information-item"
          >
            <span
              mdTooltipPosition="left"
              [mdTooltip]="
                'Label: ' + programArticle.label.id | undefinedString
              "
              >Label:</span
            >
            <a
              *ngIf="programArticle.label.value"
              [routerLink]="['/translate/11/null/', programArticle.label.value]"
            >
              <span
                [ngClass]="{
                  'not-translated': !programArticle.label.isTranslated
                }"
                >{{ programArticle.label.value | undefinedString }}</span
              >
            </a>
          </div>
          <div class="information-item">
            <span>Broadcast Id: </span>
            <a
              [href]="getInflowURL(programArticle.broadcastId)"
              target="_blank"
            >
              <b>{{ programArticle.broadcastId | undefinedString }}</b>
            </a>
          </div>
          <div class="information-item" *ngIf="programArticle.HasLastUpdate()">
            <span>Last emission update: </span>
            <b>{{ programArticle.GetUpdateDateCleaned() | undefinedString }}</b>
          </div>
          <div class="information-item" *ngIf="masterSportingEventId">
            <span
              (mouseenter)="GetSportingEventPicture()"
              mdTooltipPosition="left"
              md-tooltip="{{
                'Sporting Event Id: ' + masterSportingEventId | undefinedString
              }}"
              >Master Sporting Event:
            </span>
            <b>{{ masterSportingEventName | undefinedString }}</b>
            <p *ngIf="masterSportingEventPicture != ''" class="image-tooltip">
              <img
                (click)="editEventArticlePicture()"
                [src]="
                  masterSportingEventPicture ||
                  'https://i.eurosport.com/taiga/Pictogram/placeholder1.png'
                "
                width="150"
              />
            </p>
          </div>
          <div
            *ngIf="programArticle.isSport && programArticle.spev.id !== 0"
            class="information-item"
          >
            <a
              [routerLink]=""
              (click)="seeReplays()"
              mdTooltipPosition="left"
              md-tooltip="{{
                'Tiering: ' + programArticle.tieringName | undefinedString
              }}"
              >Sporting Event:
            </a>
            <b
              >{{ programArticle.spev.value | undefinedString }} ({{
                programArticle.spev.id
              }})</b
            >
          </div>
          <div
            *ngIf="programArticle.isSport && programArticle.spevJ0.id !== 0"
            class="information-item"
          >
            <b
              mdTooltipPosition="left"
              md-tooltip="{{
                'Tiering: ' + programArticle.tieringNameJ0 | undefinedString
              }}"
              >Sporting Event J0:
              {{ programArticle.spevJ0.value | undefinedString }} ({{
                programArticle.spevJ0.id
              }})</b
            >
          </div>
          <div
            *ngIf="
              !programArticle.isSport &&
              !programArticle.type.value &&
              !programArticle.group.value &&
              !programArticle.label.value
            "
            class="information-item"
          >
            <span>
              No Chapca classification found for this program, please refer to
              the
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=dl_programming_wbdsportseurope@discovery.com&su=Request for intervention"
                target="_blank"
              >
                programming team
              </a>
            </span>
          </div>
        </div>
        <div *ngIf="programArticle.newLevels.length > 0">
          <div
            *ngFor="
              let newLevel of programArticle.newLevels;
              let indexOfelement = index
            "
            class="information-item"
          >
            <span [mdTooltip]="'New Level Id: ' + newLevel.id | undefinedString"
              >New Level {{ indexOfelement + 1 }}:</span
            >
            <b>{{ newLevel.value | undefinedString }}</b>
          </div>
        </div>
        <div>
          <!-- TEMPORARY FIELD : INFOSUPP FROM SPINNY SINCE CHAPCA / ETT DONT HAVE IT -->
          <div
            *ngIf="!programArticle.isSport && programArticle.infosupp"
            class="information-item"
          >
            <div class="information-item">
              <span [mdTooltip]="'Temporary value from old Taiga'"
                >Infosupp (Old):
              </span>
              <b>{{ programArticle.infosupp | undefinedString }}</b>
            </div>
          </div>
          <div
            *ngIf="
              programArticle.isSport && metadatas && metadatas.cities.length > 0
            "
            class="information-item"
          >
            <span
              [mdTooltip]="'City ' + metadatas.cities[0].key | undefinedString"
              >City:</span
            >
            <span *ngFor="let city of metadatas.cities">
              <a
                *ngIf="city"
                [routerLink]="['/translate/23/null/', city.value]"
              >
                <span [ngClass]="{ 'not-translated': !city.isTranslated }">{{
                  city.value | undefinedString
                }}</span>
              </a>
              <span
                *ngIf="
                  city.value !==
                  metadatas.cities[metadatas.cities.length - 1].value
                "
                >,</span
              >
            </span>
            <b *ngIf="metadatas.cities.length === 0">n/a</b>
          </div>
          <div
            *ngIf="
              programArticle.isSport &&
              metadatas &&
              metadatas.countries.length > 0
            "
            class="information-item"
          >
            <span
              [mdTooltip]="
                'Country ' + metadatas.countries[0].key | undefinedString
              "
              >Country:</span
            >
            <span *ngFor="let country of metadatas.countries">
              <a
                *ngIf="country"
                [routerLink]="['/translate/24/null/', country.value]"
              >
                <span [ngClass]="{ 'not-translated': !country.isTranslated }">{{
                  country.value | undefinedString
                }}</span>
              </a>
              <span
                *ngIf="
                  country.value !==
                  metadatas.countries[metadatas.countries.length - 1].value
                "
                >,</span
              >
            </span>
            <b *ngIf="metadatas.countries.length === 0">n/a</b>
          </div>
          <div
            *ngIf="
              programArticle.isSport &&
              metadatas &&
              metadatas.playersTeams.length > 0
            "
            class="information-item"
          >
            <span>Players:</span>
            <span *ngFor="let player of metadatas.playersTeams">
              <a
                *ngIf="player"
                [routerLink]="['/translate/22/null/', player.value]"
              >
                <span [ngClass]="{ 'not-translated': !player.isTranslated }">{{
                  player.value + " (" + player.type + ")" | undefinedString
                }}</span>
              </a>
              <span
                *ngIf="
                  player.value !==
                  metadatas.playersTeams[metadatas.playersTeams.length - 1]
                    .value
                "
                >,</span
              >
            </span>
            <b *ngIf="metadatas.playersTeams.length === 0">n/a</b>
          </div>
          <div
            *ngIf="
              programArticle.isSport &&
              metadatas &&
              metadatas.sponsors.length > 0
            "
            class="information-item"
          >
            <span [mdTooltip]="'Sponsors: '">Sponsors: </span>
            <span *ngFor="let sponsor of metadatas.sponsors">
              <a
                *ngIf="sponsor"
                [routerLink]="['/translate/13/null/', sponsor.value]"
              >
                <span [ngClass]="{ 'not-translated': !sponsor.isTranslated }">{{
                  sponsor.value | undefinedString
                }}</span>
              </a>
              <span
                *ngIf="
                  sponsor.value !==
                  metadatas.sponsors[metadatas.sponsors.length - 1].value
                "
                >,</span
              >
            </span>
            <b *ngIf="metadatas.sponsors.length === 0">n/a</b>
          </div>
          <div
            *ngIf="
              programArticle.isSport && metadatas && metadatas.venues.length > 0
            "
            class="information-item"
          >
            <span [mdTooltip]="'Venues: '">Venues: </span>
            <span *ngFor="let venue of metadatas.venues">
              <a
                *ngIf="venue"
                [routerLink]="['/translate/14/null/', venue.value]"
              >
                <span [ngClass]="{ 'not-translated': !venue.isTranslated }">{{
                  venue.value | undefinedString
                }}</span>
              </a>
              <span
                *ngIf="
                  venue.value !==
                  metadatas.venues[metadatas.venues.length - 1].value
                "
                >,</span
              >
            </span>
            <b *ngIf="metadatas.venues.length === 0">n/a</b>
          </div>
          <div
            *ngIf="
              programArticle.isSport &&
              programArticle.spev !== 0 &&
              programArticle.spev.id !== 0 &&
              programArticle.commentator
            "
            class="information-item"
          >
            <span [mdTooltip]="programArticle.commentator">Commentators: </span>
            <app-spinner *ngIf="loadingCommentator"></app-spinner>
            <b>{{ programArticle.getCommentatorShort() }}</b>
          </div>
          <div
            *ngIf="
              programArticle.isSport &&
              metadatas &&
              metadatas.federations.length > 0
            "
            class="information-item"
          >
            <span
              [mdTooltip]="
                'Federation Id: ' + metadatas.federations[0].key
                  | undefinedString
              "
              >Federation:
            </span>
            <span *ngFor="let federation of metadatas.federations">
              <b>{{ federation.value | undefinedString }}</b>
              <span
                *ngIf="
                  federation.value !==
                  metadatas.federations[metadatas.federations.length - 1].value
                "
                >,</span
              >
            </span>
            <b *ngIf="metadatas.federations.length === 0">n/a</b>
          </div>
          <div
            *ngIf="programArticle.isSport && programArticle.variant.id !== 0"
            class="information-item"
          >
            <span
              [mdTooltip]="
                'Variant Id: ' + programArticle.variant.id | undefinedString
              "
              >Variant:
            </span>
            <b>{{ programArticle.variant.value | undefinedString }}</b>
          </div>
          <div
            *ngIf="programArticle.isSport && programArticle.variantJ0.id !== 0"
            class="information-item"
          >
            <span
              [mdTooltip]="
                'Variant Id: ' + programArticle.variantJ0.id | undefinedString
              "
              >Variant J0:
            </span>
            <b>{{ programArticle.variantJ0.value | undefinedString }}</b>
          </div>
          <!-- TEMPORARY FIELD : PLAYERS FROM SPINNY SINCE CHAPCA / ETT DONT HAVE IT -->
          <div class="information-item" *ngIf="programArticle.playersPSG">
            <div class="information-item">
              <span [mdTooltip]="'Temporary value from old Taiga'"
                >Players (Old):
              </span>
              <b>{{ programArticle.playersPSG | undefinedString }}</b>
            </div>
          </div>
        </div>
        <div>
          <div
            class="information-item"
            *ngIf="
              programArticle.programId !== 0 && programArticle.programId !== -1
            "
          >
            <a [routerLink]="" (click)="seeReplays()">Program Id: </a>
            <b>{{ programArticle.programId | undefinedString }}</b>
          </div>
          <div
            class="information-item"
            *ngIf="programArticle.contentId && programArticle.contentId !== '0'"
          >
            <a [routerLink]="" (click)="seeReplays()">Content Id: </a>
            <b>{{ programArticle.contentId | undefinedString }}</b>
          </div>
          <div class="information-item" *ngIf="programArticle.transmissionId">
            <span>Transmission Id: </span>
            <b>{{ programArticle.transmissionId | undefinedString }}</b>
          </div>
          <div
            class="information-item"
            *ngIf="programArticle.btSportProductCode"
          >
            <span>Product code: </span>
            <a
              [routerLink]="['/tnt-sports/', programArticle.btSportProductCode]"
            >
              <span
                [ngClass]="{
                  'not-translated':
                    programArticle.spev.id === 0 && !programArticle.type.id
                }"
                >{{ programArticle.btSportProductCode | undefinedString }}</span
              >
            </a>
          </div>
          <div class="information-item">
            Start date:
            <b>{{
              programArticle.startDate
                | date : "dd/MM/yy - HH:mm"
                | undefinedString
            }}</b>
          </div>
          <div class="information-item">
            End date:
            <b>{{
              programArticle.endDate
                | date : "dd/MM/yy - HH:mm"
                | undefinedString
            }}</b>
          </div>
          <div class="information-item">
            Length: <b>{{ programArticle.length | undefinedString }}</b>
          </div>
          <div class="information-item">
            <span
              [mdTooltip]="
                'Channel ' + programArticle.channel.id | undefinedString
              "
              >Channel:</span
            >
            <b>{{ programArticle.channel.value | undefinedString }}</b>
          </div>
          <div class="information-item">
            <span
              [mdTooltip]="
                'Broadcasting ' + programArticle.broadcasting.id
                  | undefinedString
              "
              >Broadcasting:</span
            >
            <b>{{ programArticle.broadcasting.value | undefinedString }}</b>
          </div>
          <div *ngIf="programArticle.isMultiCam" class="information-item">
            <span>Cam type:</span> <b>{{ programArticle.getMultiCamType() }}</b>
          </div>
        </div>
      </div>
    </md-card>
    <div class="tabs">
      <md2-tabs
        *ngIf="programArticle && programArticle.destinations.length > 0"
        [(selectedIndex)]="selectIndex"
        class="program-type-tab"
      >
        <md2-tab
          [label]="destination.id"
          *ngFor="
            let destination of programArticle.destinations
              | filterByDestination : currentUser;
            let indexOfelement = index
          "
          [active]="selectIndex == indexOfelement"
        >
          <app-program-article-form
            [destination]="destination"
            [programArticle]="programArticle"
            [currentUser]="currentUser"
            [editMode]="
              adminService.can('Program Article ' + destination.id, 'Edit')
            "
            (saveProgramAndReplays)="saveProgramAndReplays()"
            (saveProgramOnly)="saveProgramOnly()"
            (seeReplays)="seeReplays()"
            (seeMultiCams)="seeMultiCams()"
            (seeAdditionalPictures)="seeAdditionalPictures()"
            (duplicateData)="duplicateData()"
            (duplicateDigitalDataToPartners)="duplicateDigitalDataToPartners()"
            (initialData)="initialData()"
            (initialPartnersData)="initialPartnersData()"
            (duplicatePressInter)="duplicatePressInter()"
            (duplicateInter)="duplicateInter(destination.id)"
            (deleteDataInter)="deleteDataInter(destination.id)"
          >
          </app-program-article-form>
        </md2-tab>
      </md2-tabs>
    </div>
  </div>
</div>

<app-spinner *ngIf="loading"></app-spinner>



// WEBPACK FOOTER //
// ./src/app/components/program-article-details/program-article-details.component.html